"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ecommerce_1 = require("../../api/ecommerce");
const configuration_1 = __importDefault(require("../apis/configuration/shop/configuration"));
class ShopwareProductSearch {
    api = new ecommerce_1.ProductSearchApi(configuration_1.default);
    searchProducts(productSearchRequestBody) {
        return this.api.searchProducts({
            productSearchRequestBody: productSearchRequestBody
                ? {
                    ...productSearchRequestBody,
                    includes: __APP__.PRODUCT_REQUEST_BODY_INCLUDES,
                    associations: {
                        ...(productSearchRequestBody?.associations || {}),
                        categories: { ' ': 1 },
                        properties: {
                            associations: {
                                group: { ' ': 1 },
                                translations: { ' ': 1 },
                            },
                        },
                    },
                }
                : undefined,
        });
    }
}
exports.default = new ShopwareProductSearch();
